if (!customElements.get('mobile-menu')) {
  customElements.define(
    'mobile-menu',
    class MobileMenu extends HTMLElement {
      connectedCallback() {
        this.toggles = document.querySelectorAll(`[aria-controls="${this.id}"]`);
        this.desktopQuery = window.matchMedia('(min-width: 901px)');
        this.inertElements = [];

        this.onToggleClick = this.onToggleClick.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onDesktopChange = this.onDesktopChange.bind(this);
        this.onPageShow = this.onPageShow.bind(this);

        this.toggles.forEach((toggle) => toggle.addEventListener('click', this.onToggleClick));
        this.addEventListener('click', this.onClick);
        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onDocumentClick = this.onDocumentClick.bind(this));
        this.desktopQuery.addEventListener('change', this.onDesktopChange);
        window.addEventListener('pageshow', this.onPageShow);
      }

      disconnectedCallback() {
        this.toggles.forEach((toggle) => toggle.removeEventListener('click', this.onToggleClick));
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onDocumentClick);
        this.desktopQuery.removeEventListener('change', this.onDesktopChange);
        window.removeEventListener('pageshow', this.onPageShow);
        if (this.isOpen) this.close(false);
      }

      get isOpen() {
        return this.hasAttribute('open');
      }

      onToggleClick(event) {
        event.preventDefault();
        this.isOpen ? this.close() : this.open(event.currentTarget);
      }

      onClick(event) {
        if (event.target.closest('[data-mobile-menu-close]')) {
          event.preventDefault();
          this.close();
        }
      }

      onDocumentClick(event) {
        if (this.isOpen && event.target.closest('.header-cart')) this.close(false);
      }

      onKeydown(event) {
        if (this.isOpen && event.key === 'Escape') {
          event.preventDefault();
          this.close();
        }
      }

      onPageShow(event) {
        if (event.persisted && this.isOpen) this.close(false);
      }

      onDesktopChange(event) {
        if (event.matches && this.isOpen) this.close(false);
      }

      open(trigger) {
        this.trigger = trigger || this.toggles[0];
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        this.setOffset();
        this.setToggleState(true);
        document.documentElement.classList.add('mobile-menu-open');
        this.setPageInert(true);

        const firstFocusable = this.querySelector('a[href], summary');
        if (firstFocusable) firstFocusable.focus({ preventScroll: true });
      }

      close(restoreFocus = true) {
        this.removeAttribute('open');
        this.setAttribute('aria-hidden', 'true');
        this.setToggleState(false);
        document.documentElement.classList.remove('mobile-menu-open');
        this.setPageInert(false);

        if (restoreFocus && this.trigger) this.trigger.focus({ preventScroll: true });
      }

      setOffset() {
        const header = document.querySelector('[data-mobile-menu-keep]');
        if (!header) return;
        const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        this.style.setProperty('--mobile-menu-top', `${bottom}px`);
      }

      setToggleState(open) {
        this.toggles.forEach((toggle) => {
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          const label = open ? toggle.dataset.labelClose : toggle.dataset.labelOpen;
          if (label) toggle.setAttribute('aria-label', label);
        });
      }

      setPageInert(inert) {
        if (!inert) {
          this.inertElements.forEach((element) => element.removeAttribute('inert'));
          this.inertElements = [];
          return;
        }

        let node = this;
        while (node && node !== document.body) {
          const parent = node.parentElement;
          if (!parent) break;
          Array.from(parent.children).forEach((sibling) => {
            if (sibling === node || sibling.hasAttribute('inert')) return;
            if (sibling.matches('[data-mobile-menu-keep]') || sibling.querySelector('[data-mobile-menu-keep]')) return;
            if (['SCRIPT', 'STYLE', 'LINK', 'TEMPLATE'].includes(sibling.tagName)) return;
            sibling.setAttribute('inert', '');
            this.inertElements.push(sibling);
          });
          node = parent;
        }
      }
    },
  );
}
